import { QTY_LIMITS, isWholeNumber, roundQty } from "../util/quantity";

const MAX_QTY = QTY_LIMITS.max;

/** count × pack + extra, or null when the result cannot be posted as quantity. */
export const packQuantityTotal = (
	count: number,
	pack: number,
	extra: number,
	fractional = false,
): number | null => {
	if (count < 0 || pack < 1 || extra < 0) return null;
	if (!Number.isFinite(count) || !Number.isFinite(pack) || !Number.isFinite(extra)) {
		return null;
	}
	if (!fractional) {
		if (!Number.isInteger(count) || !Number.isInteger(pack) || !Number.isInteger(extra)) {
			return null;
		}
	}

	const product = count * pack;
	const total = roundQty(product + extra);
	if (total <= 0 || total > MAX_QTY) return null;
	if (!fractional && (total < 1 || !isWholeNumber(total))) return null;

	return total;
};
